import Lock from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { useState } from "react";

import Input, { InputProps } from "./Input";

const Password = (props: InputProps) => {
  const { control, name, ...rest } = props;
  const [showToggle, setShowToggle] = useState(false);

  return (
    <Input
      name={name}
      type={!showToggle ? "password" : "text"}
      control={control}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Lock />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowToggle(!showToggle)}
              edge="end"
              tabIndex={-1}
            >
              {showToggle ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...rest}
    />
  );
};

export default Password;
